document.addEventListener('DOMContentLoaded', function () {
    const targets = document.querySelectorAll('.fade-in-up');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
            }
        });
    }, { threshold: 0.3 });

    targets.forEach(target => observer.observe(target));

    // ファーストビューのテキスト順番アニメーション
    const fvTextPs = document.querySelectorAll('.first_view_text p');
    if (fvTextPs.length) {
        fvTextPs.forEach((p, i) => {
            setTimeout(() => {
                p.classList.add('is-visible');
            }, 150 + i * 150);
        });
    }
    const firstView = document.querySelector('.first_view');
    if (firstView) {
        document.body.style.overflow = 'hidden';
        setTimeout(() => {
            firstView.classList.add('hide');
            setTimeout(() => {
                firstView.style.display = 'none';
                document.body.style.overflow = '';
            }, 800); // transitionと同じ秒数
        }, 2000); // 表示時間（2秒）
    }

    // trouble_itemの順番アニメーション
    const troubleItems = document.querySelectorAll('.trouble_item');
    if (troubleItems.length) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    troubleItems.forEach((item, i) => {
                        setTimeout(() => {
                            item.classList.add('is-visible');
                        }, i * 200);
                    });
                    observer.disconnect();
                }
            });
        }, { threshold: 0.3 });
        observer.observe(troubleItems[0].parentElement);
    }

    // features_itemの順番アニメーション
    const featuresItems = document.querySelectorAll('.features_item');
    if (featuresItems.length) {
        const featuresObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    featuresItems.forEach((item, i) => {
                        setTimeout(() => {
                            item.classList.add('is-visible');
                        }, i * 200);
                    });
                    featuresObserver.disconnect();
                }
            });
        }, { threshold: 0.3 });
        featuresObserver.observe(featuresItems[0].parentElement);
    }

    // reason_itemのh3に順番アニメーション
    const reasonItems = document.querySelectorAll('.reason_item .text_contain h3');
    const reasonObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry, i) => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    entry.target.classList.add('is-visible');
                }, i * 200); // 順番に
            }
        });
    }, { threshold: 0.5 });

    reasonItems.forEach(item => reasonObserver.observe(item));

    // voice_itemのtext_containにディゾルブ表示
    const voiceTextContainers = document.querySelectorAll('.customer_voice_item .customer_text_contain');
    if (voiceTextContainers.length) {
        const voiceObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry, i) => {
                if (entry.isIntersecting) {
                    setTimeout(() => {
                        entry.target.classList.add('p-is-visible');
                    }, i * 200);
                    voiceObserver.unobserve(entry.target);
                }
            });
        }, { threshold: 0.5 });
        voiceTextContainers.forEach(item => voiceObserver.observe(item));
    }
});

window.addEventListener('load', () => {
    const tracks = document.querySelectorAll('.gallery-track');

    tracks.forEach(track => {
        const itemCount = track.children.length;
        if (!itemCount) return;

        // 1セット → 2セット に複製
        track.innerHTML += track.innerHTML;

        const children = track.children;

        // 1セット目の先頭 と 2セット目の先頭 の位置差 = 1周分
        let cycleWidth = children[itemCount].offsetLeft - children[0].offsetLeft;

        // ★ ここが今回のキモ：小数になっている可能性があるので整数に丸める
        cycleWidth = Math.round(cycleWidth);

        const speed = 0.5;
        let distance = 0;

        function loop() {
            distance += speed;

            // 1周分で割った余りだけを使う
            const x = -(distance % cycleWidth);

            track.style.transform = `translate3d(${x}px, 0, 0)`;
            requestAnimationFrame(loop);
        }

        loop();
    });
});
